import { Box, Container, Spacer } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import PersonalManagerChatCard from 'presentation/containers/modules/chat/detail/PersonalManagerChatCard';
import PortfolioAccountsContainer from 'presentation/containers/modules/portfolio/PortfolioAccountsContainer';
import PortfolioCurrenciesContainer from 'presentation/containers/modules/portfolio/PortfolioCurrenciesContainer';
import PageLayout from 'presentation/layout/shared/page/PageLayout';
import SidebarLayout from 'presentation/layout/shared/SidebarLayout';
import { FC, PropsWithChildren } from 'react';

const PortfolioPageLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <PageLayout>
      <Container display="flex" alignItems="flex-start">
        <SidebarLayout>
          <PortfolioAccountsContainer />
          <Spacer h="20px" />
          <PortfolioCurrenciesContainer />
          <PersonalManagerChatCard
            mt="20px"
            roomType={ChatRoomType.PersonalManager}
          />
        </SidebarLayout>
        <Box flex="1" overflowX="auto">
          {children}
        </Box>
      </Container>
    </PageLayout>
  );
};

export default PortfolioPageLayout;
